import { CAMPO_OBRIGATORIO, EMAIL_INVALIDO } from './constants';
import { NgForm } from '@angular/forms';

export class FormValidator {

    public isInvalidAndTouched(formName){
        if(formName.invalid && formName.touched){
            return CAMPO_OBRIGATORIO;
        }
        return '';
    }

    public isInvalidEmail(formName){
        if(this.isInvalidAndTouched(formName)){
            if(formName.value){
                return EMAIL_INVALIDO;
            }
            return CAMPO_OBRIGATORIO;
        }
        return '';
    }

    public setTouchedValues(form: NgForm){
        for (let property in form.controls){
            form.controls[property].markAsTouched();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/base/util/form-validator.ts